import { FontConfig } from "@tfg/ui"

export const FONT_CONFIG: Record<string, FontConfig> = {
  Inter: {
    fontFamily: "Inter",
    cssPath: "/fonts/css/inter.css",
    className: "font-inter",
  },
  roboto: {
    fontFamily: "roboto",
    cssPath: "/fonts/css/roboto.css",
    className: "font-roboto",
  },
  rand: {
    fontFamily: "rand",
    cssPath: "/fonts/css/rand.css",
    className: "font-open-sans",
  },
  Poppins: {
    fontFamily: "Poppins",
    cssPath: "/fonts/css/poppins.css",
    className: "font-poppins",
  },
  "haylard-display": {
    fontFamily: "haylard-display",
    cssPath: "/fonts/css/haylard.css",
    className: "font-haylard",
  },
  "haylard-text": {
    fontFamily: "haylard-text",
    cssPath: "/fonts/css/haylard.css",
    className: "font-haylard",
  },
  Outfit: {
    fontFamily: "Outfit",
    cssPath: "/fonts/css/outifit.css",
    className: "font-outfit",
  },
  Calibre: {
    fontFamily: "Calibre",
    cssPath: "/fonts/css/calibre.css",
    className: "font-calibre",
  },
  domaine: {
    fontFamily: "domaine",
    cssPath: "/fonts/css/domaine.css",
    className: "font-domaine",
  },
  "freight-text-pro": {
    fontFamily: "freight-text-pro",
    cssPath: "/fonts/css/freight-text.pro.css",
    className: "font-freight-text-pro",
  },
  graphik: {
    fontFamily: "graphik",
    cssPath: "/fonts/css/graphik.css",
    className: "font-graphik",
  },
  bebas: {
    fontFamily: "bebas",
    cssPath: "/fonts/css/bebas.css",
    className: "font-bebas",
  },
  "galano-grotesque": {
    fontFamily: "galano-grotesque",
    cssPath: "/fonts/css/galano-grotesque.css",
    className: "font-galano-grotesque",
  },
  montserrat: {
    fontFamily: "montserrat",
    cssPath: "/fonts/css/montserrat.css",
    className: "font-montserrat",
  },
  default: {
    fontFamily: "poppins",
    cssPath: "/fonts/css/poppins.css",
    className: "font-poppins",
  },
}
